import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	yAxisLabel: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.chart.y-axis-label',
		defaultMessage: 'Deployment frequency',
		description: 'Y axis label indicating y axis value is the number of deployments.',
	},
});
